import * as React from 'react';

export interface OnClickOutsideProps {
  className?: string;
  onClickOutside: () => void;
  tabIndex?: number;
  children?: React.ReactNode;
}
export interface OnClickOutsideState {
  clickedInside: boolean;
}

export class OnClickOutside extends React.Component<OnClickOutsideProps, OnClickOutsideState> {
  private wrapperRef: HTMLDivElement;

  public componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  private clickedScrollbar = (event: any) => {
    return (event.target.clientWidth > 0 && event.offsetX > event.target.clientWidth)
      || (event.target.clientHeight > 0 && event.offsetY > event.target.clientHeight);
  };

  /**
   * Set the wrapper ref
   */
  public setWrapperRef = (node: HTMLDivElement) => {
    this.wrapperRef = node;
  };

  /**
   * Alert if clicked on outside of element
   */
  public handleClickOutside = (event: any) => {
    if (!this.clickedScrollbar(event)
      && this.wrapperRef
      && !this.wrapperRef.contains(event.target)) {
      this.props.onClickOutside();
    }
  };

  public render() {
    return (<div ref={this.setWrapperRef} className={this.props.className} >
      {this.props.children}
    </div>);
  }
}
